import { render } from "./PivotYearManagement.vue?vue&type=template&id=e6a7c7cc"
import script from "./PivotYearManagement.vue?vue&type=script&lang=js"
export * from "./PivotYearManagement.vue?vue&type=script&lang=js"

import "./PivotYearManagement.vue?vue&type=style&index=0&id=e6a7c7cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__